import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import AudioSegment from "models/audioEditor/segments/AudioSegment";
import RSVP from "rsvp";

const CLASSNAME = "PunctuationAudioSegment";
const PunctuationAudioSegment =  AudioSegment.extend({
    idAttribute: "id",

    constructor: function(attributes, options) {
        AudioSegment.apply(this, [attributes, options]);
        this.set("type", PunctuationAudioSegment.CLASSNAME);
    },

    clone: function(){
        return new PunctuationAudioSegment(this.toJSON());
    },

    
});

PunctuationAudioSegment.CLASSNAME = CLASSNAME;
export default PunctuationAudioSegment; 